import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {BroadcastChannelTypeEnum, BroadcastMessageTypeEnum} from 'app/models';
import { BroadcastMessageComponent } from '../broadcast-message/broadcast-message.component';

@Component({
    selector: 'broadcast-message-filter',
    templateUrl: './broadcast-message-filter.component.html',
    styleUrls: ['./broadcast-message-filter.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'    ]
})
export class BroadcastMessageFilterComponent implements OnInit {

    constructor() { }

    @Input()
    public broadcastMessageComponent!: BroadcastMessageComponent;

    public dateAndTime!: Date | null;
    @Input()
    set _dateAndTime(dateAndTime: Date) {
        this.dateAndTime = dateAndTime;
    }

    @Input()
    public isVisibleBroadcastMessageFilter: boolean = false;

    @Output() changedVisibleBroadcastMessageFilterEmit = new EventEmitter<boolean>();
    changedVisibleBroadcastMessageFilter(increased: any) {
        this.changedVisibleBroadcastMessageFilterEmit.emit(increased);
    }

    public broadcastMessageType = BroadcastMessageTypeEnum;
    @Input()
    public broadcastMessageTypes: BroadcastMessageTypeEnum[] = [];

    public broadcastChannelType = BroadcastChannelTypeEnum;
    @Input()
    public broadcastChannelTypes: BroadcastChannelTypeEnum[] = [];

    ngOnInit(): void {
    }

    public doneFilter() {
        this.broadcastMessageComponent.broadcastMessageHeaderSearch.dateAndTime = this.dateAndTime;
        this.broadcastMessageComponent.broadcastMessageHeaderSearch.broadcastMessageTypes = this.broadcastMessageTypes;
        this.broadcastMessageComponent.broadcastMessageHeaderSearch.broadcastChannelTypes = this.broadcastChannelTypes;
        this.broadcastMessageComponent.getBroadcastMessages(0);
        this.cancel();
    }

    public clearFilter() {
        this.dateAndTime = null;
        this.broadcastMessageTypes = [];
        this.broadcastChannelTypes = [];
    }

    cancel() {
        this.changedVisibleBroadcastMessageFilter(false);
    }
}
